import { computed } from 'vue';
import useAcvStore from '@/composables/useAcvStore';
import featureFlagSlugs from '@/constants/featureFlagSlugs';

const useAcvFeatureFlags = () => {
  const store = useAcvStore();
  const ff = computed(() => store.state.featureFlags);

  const getFlag = (slug) => computed(() => ff.value.flags[featureFlagSlugs[slug]]);

  return { getFlag };
};

export default useAcvFeatureFlags;
